import { FC, ReactNode } from 'react';

import { PaperProps } from '@o2/ui/Paper';

import LinkBoxList from '../LinkBoxList';
import Item from './Item';

export interface FileListProps extends Omit<PaperProps, 'title'> {
  children: ReactNode;

  /**
   * Disable styling the passed `title` as a heading.
   *
   * Defaults to false (= does style) if `title` is a string,
   * true otherwise (if you pass a ReactElement, for example, it will not be styled).
   *
   * Useful to override for example when composing the text content from several `<span/>`s.
   */
  disableTitleStyling?: boolean;

  /**
   * If a string, it will be wrapped in a h5 Typography (unless `disableTitleStyling` is true). For customization, you can
   * pass any ReactNode, such as your own Typography instance.
   */
  title?: ReactNode;
}

type FileList = FC<FileListProps> & {
  Item: typeof Item;
};

const FileList: FileList = ({ children, title, disableTitleStyling = typeof title !== 'string', ...paperProps }) => {
  return (
    <LinkBoxList heading={title} disableHeadingStyling={disableTitleStyling} {...paperProps}>
      {children}
    </LinkBoxList>
  );
};

FileList.Item = Item;

export default FileList;
